/**
 * About component
 *
 * Space for you to describe more about yourself.
 */

import React from "react";

/**
 * About background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that 
 * represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a image you
 * freely use on your site.
 */
import image from "../images/socials/Color 6.avif";

const imageAltText = "purple and blue abstract background";

/**
 * Sort description that expands on your title on the Home component.
 */
const description =
  "I have done B.Com from University of Karachi. Afterwards, I did M.A. in English Literature from Federal Urdu University of Arts, Science and Technology. I have recently completed my B.Ed specialization in Information Communication Technology (ICT) in education from Virtual University of Pakistan online. I have a passion for learning Computer Digital Technology. I am grateful to Microsoft MLSA for selecting me as a Student Ambassador from Pakistan in 2023. It is a great privilege for me and my country. I cannot express my feelings.";

/**
 * List of some of skills or technologies you work on, are learning,
 * passionate about, or enjoy,
 */
const skillsList = [
  "Making Tutorials",
  "Free writing",
  "Web design",
  "MS Office",
  "Product Management",
  "Collage Making",
  "Internet of Things",
  "Artificial Intelligence",
  "Python",
];

/**
 * Use this to give more information about what you are passionate about,
 * how you best work, or even a quote. This will help someone learn more
 * about you on a professional level.
 */
const detailOrQuote =
  "I like to read computer tech articles, blogs, watch tutorials, surf internet. I think when you can work hard you can attain your dreams. Dedication and skills play a pivotal role in achieving success.";

const About = () => {
  return (
    <section className="padding" id="about">
      <img className="background" src={image} alt={imageAltText} />
      <div
        style={{
          backgroundColor: "white",
          width: "50%",
          padding: "4rem",
          margin: "3rem auto",
          textAlign: "center",
        }}
      >
        <h2>About Myself</h2>
        <p className="large">{description}</p>
        <hr />
        <ul
          style={{
            textAlign: "left",
            columns: 2,
            fontSize: "1.25rem",
            margin: "2rem 3rem",
            gap: "3rem",
          }}
        >
          {skillsList.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <hr />
        <p style={{ padding: "1rem 3rem 0" }}>{detailOrQuote}</p>
      </div>
    </section>
  );
};

export default About;
